import CustomTextInput from '../atoms/custom-text-input.atom';
const InputOpen = ({ question, answer, onAnswerChange, id, isLoading=false, neighborhoodOptions = [] }) => {
  return (
    <>
     <CustomTextInput
                    label={question.label || 'Pregunta sin título'}
                    placeholder={question.placeholder || 'Escribe tu respuesta aquí'}
                    value={answer}
                    onChange={onAnswerChange}
                    maxLength={question.maxLength || 50}
                    disabled={isLoading}
                    inputContainerStyle={neighborhoodOptions?.length === 0 ? {borderColor: '#FACE07', borderWidth: 2} : {}}
                    error={''}
                    id={`question-${id}`}
                />
    </>

    
  );
};

export default InputOpen;
